import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { payWithPayPal } from './transferSlice';

import PaymentFooter from './PaymentFooter';

export default function PayPalDetails() {
  const dispatch = useDispatch();
  const isPopupBlocked = useSelector((state) => state.error.isPopupBlocked);

  const handlePay = () => dispatch(payWithPayPal());

  const errorText = useMemo(
    () =>
      isPopupBlocked
        ? 'Please allow popup window to be able to continue with payment. And press button bellow.'
        : undefined,
    [isPopupBlocked]
  );

  return <PaymentFooter text="Pay with PayPal" errorText={errorText} onPay={handlePay} />;
}
